import {
  Grid,
  Typography,
  Button,
  Box,
  CircularProgress,
} from "@mui/material";
import { useState } from "react";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { useTheme } from "@mui/material/styles";
import { chargeUploadReport } from "../../services/LegalFileService";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import DynamicExcelHelpModal from "../General/DynamicExcelHelpModal";
import Tooltip from "@mui/material/Tooltip";
import CardHeader from "../General/CardHeader";
import GlassCard from "../General/GlassCard";
import { useToast } from "../../context/ToastContext";
import FileUploadBox from "../General/FileUploadBox"; // 👈 Importación

export default function ChargeNumberReport() {
  const { showToast } = useToast();
  const theme = useTheme();

  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ numerosReportes: "" });
  const [errors, setErrors] = useState({});
  const [selectedFile, setSelectedFile] = useState(null);
  const [openHelp, setOpenHelp] = useState(false);
  const handleOpenHelp = () => setOpenHelp(true);
  const handleCloseHelp = () => setOpenHelp(false);

  // Adaptado para recibir el archivo desde el componente Drag & Drop
  const handleFileSelect = (file) => {
    if (file) {
      const validExtensions = ["xls", "xlsx"];
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (!validExtensions.includes(fileExtension)) {
        setErrors({
          ...errors,
          numerosReportes: "Solo se permiten archivos .xls o .xlsx",
        });
        setSelectedFile(null);
        setForm({ ...form, numerosReportes: "" });
        return;
      }
      setErrors({ ...errors, numerosReportes: "" });
      setSelectedFile(file);
      setForm({ ...form, numerosReportes: file.name });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();    setErrors({});
    setLoading(true);

    if (!selectedFile) {
      showToast("Debe seleccionar un archivo.", "info")
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("numerosReportes", selectedFile);

    try {
      const response = await chargeUploadReport(formData);

      if (response.data.status === "success") {
        const link = document.createElement("a");
        link.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${response.data.file}`;
        link.download = response.data.filename || "operation_report.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        showToast("Reporte generado correctamente", "success")
        setSelectedFile(null); // Limpiar archivo tras éxito
        setForm({ numerosReportes: "" });
      } else {
        showToast("Error al generar reporte.", "error")
      }
    } catch (error) {
      if (error.response?.status === 422 || error.response?.status === 404) {
        showToast(error.response.data?.message || "Ocurrió un error.", "error")
      } else if (error.response?.data?.errors) {
        const apiErrors = {};
        Object.keys(error.response.data.errors).forEach((key) => {
          apiErrors[key] = error.response.data.errors[key][0];
        });
        setErrors(apiErrors);
      } else {
        console.log(error);
        showToast("Ocurrió un error inesperado.", "error")
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid container justifyContent="center" sx={{ mt: 4 }}>
      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 10 }}>

        <GlassCard>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Tooltip title="Ver requisitos del Excel" arrow>
              <HelpOutlineIcon
                sx={{
                  cursor: "pointer",
                  color: theme.palette.primary.main,
                  "&:hover": { color: theme.palette.primary.dark },
                }}
                onClick={handleOpenHelp}
              />
            </Tooltip>
          </Box>

          <CardHeader
            icon={<AssignmentIcon />}
            title="Carga de Expedientes para reportes"
            description="Subir codigos de expediente para generar reporte"
          />

          <Box component="form" onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12 }}>
                <FileUploadBox
                  selectedFile={selectedFile}
                  onFileSelect={handleFileSelect}
                  accept=".xls,.xlsx"
                  placeholder="Seleccionar Excel para Reporte"
                  helperText="O arrastrá el archivo Excel aquí (.xls, .xlsx)"
                />
                {errors.numerosReportes && (
                  <Typography
                    color="error"
                    variant="caption"
                    sx={{ mt: 1, display: "block" }}
                  >
                    {errors.numerosReportes}
                  </Typography>
                )}
              </Grid>

              <Grid size={{ xs: 12 }}>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  fullWidth
                  disabled={loading}
                 
                >
                  {loading ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    "Generar Reportes"
                  )}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </GlassCard>
      </Grid>

      <DynamicExcelHelpModal
        open={openHelp}
        onClose={handleCloseHelp}
        title="Requisitos del archivo Excel"
        description="El archivo debe ser formato .xls o .xlsx."
        columns={["Código de Expediente"]}
        example={["12345678"]}
      />
    </Grid>
  );
}
